import React from "react";
import {
  View,
  Dimensions,
  TouchableOpacity,
  Platform,
  Text,
  TextInput,
  ActivityIndicator,
} from "react-native";

import { Image } from 'expo-image'
// import { LinearGradient } from 'expo-linear-gradient';

import * as Constants from "../utils/Constants";
import * as Commons from "../utils/Commons";
import * as AppStyles from "../utils/appStyles";
// import * as Styles from '../utils/Styles';
import { STRINGS } from "../utils/Strings";

// let width = (xwidth - 80) / (Commons.getNumColumns() + 1);
let width = 0;
let direction = "left";
let curLanguage = "";
let styles = {};
let isMobile = false;
let scale = 1;
const plus = require("../images/Shop/plus.png");
const minus = require("../images/Shop/minus.png");
const circlePlus = require("../images/Shop/circlePlus.png");
const giftIcon2 = require("../images/RedGift2.png");
const giftIcon3 = require("../images/GreenGift2.png");
const awaitingRestock = require("../images/awaitingrestock.png");

// Shared short-lived cache so a list re-render doesn't fire one storage read per item.
let basketMapPromise = null;
let basketMapReadAt = 0;
let basketMapRev = -1;
const getBasketMap = () => {
  const now = Date.now();
  const rev = Commons.basketMapRevision.value;
  if (!basketMapPromise || rev !== basketMapRev || now - basketMapReadAt > 150) {
    basketMapReadAt = now;
    basketMapRev = rev;
    basketMapPromise = Commons.getFromAS(Constants.ITEMS_MAP_IN_BASKET);
  }
  return basketMapPromise;
};

// Rapid qty taps/keystrokes keep updating the UI instantly; the basket write only
// runs once, this long after the last change.
const QTY_UPDATE_DEBOUNCE_MS = 1000;

// let loggedIn = true;
class FeaturedItem extends React.PureComponent {
  constructor(props) {
    super(props);
    curLanguage = STRINGS.curLanguage;
    this.state = {
      Qty: 0,
      direction: "left",
      loggedIn: true,
      isHovered: false,
      tempQty: 1,
      orderResponse: [],
      isSearch: false,
      updatedItem: undefined,
      orgItem: undefined
    };
  }


  async componentDidMount() {
    // const language = this.props.language;
    // const loggedIn = this.props.loggedIn;
    // const outOfStockMsg = this.props.outOfStockMsg;
    // direction = language.startsWith("ar") ? "right" : "left";
    // this.setState({ direction, loggedIn, outOfStockMsg });
    const { isSearch } = this.props;
    this.setState({ orgItem: JSON.parse(JSON.stringify(this.props.item)) });
    if (isSearch !== undefined) {
      this.setState({ isSearch: isSearch && Commons.isMobile() });
    }

  }

  // A qty change only reaches ITEMS_MAP_IN_BASKET after the debounce plus a server
  // round-trip (calculateOrderPrice -> updateBasketItemsMap), so until then the
  // stored map still holds the previous value.
  isQtyChangePending(itemID) {
    return this.addToBasketTimeout != null || !!this.state[`calculating_${itemID}`];
  }

  // Keeps the header cart button unpressable while this card's change is still being
  // written, so checkout can't be opened against a half-written basket.
  setBasketBusy(busy) {
    if (this.basketBusy === busy) return;
    this.basketBusy = busy;
    Commons.setBasketWritePending(busy ? 1 : -1, this);
  }

  UNSAFE_componentWillReceiveProps() {
    if (!this.props.item || this.props.item.isDummy) return;
    const itemID = this.props.item.ID;
    getBasketMap().then((map) => {
      if (map) {
        const stored = JSON.parse(map)[itemID];
        // An absent or zero-qty entry means the item is not in the basket.
        const inBasket = !!stored && !stored.isDummy && parseInt(stored.qty) > 0;
        // While a change is in flight the map is behind it, so the local card owns
        // its qty and stepper state until the write lands.
        const qtyPending = this.isQtyChangePending(itemID);
        if (inBasket) {
          if (!qtyPending) {
            this.props.item.qty = stored.qty;
            this.props.item.BONUS = stored.BONUS;
            this.props.item.NEXT_BONUS_TEXT_LONG = stored.NEXT_BONUS_TEXT_LONG;
            this.props.item.NEXT_BONUS_TEXT = stored.NEXT_BONUS_TEXT;
            this.props.item.NEXT_BONUS = stored.NEXT_BONUS;
          }
          if (JSON.stringify(this.props.item) !== JSON.stringify(this.state.updatedItem)) {
            const nextState = {
              updatedItem: JSON.parse(JSON.stringify(this.props.item))
            };
            if (!qtyPending) {
              nextState[`itemQty${itemID}`] = stored.qty;
              nextState[`cartPressed_${itemID}`] = true;
            }
            this.setState(nextState);
          }
        } else if (!qtyPending && (this.state[`cartPressed_${itemID}`] || (this.state[`itemQty${itemID}`] || 0) > 0)) {
          // Item left the basket: drop the stepper back to the single (+) button.
          this.setState({
            updatedItem: JSON.parse(JSON.stringify(this.props.item)),
            [`itemQty${itemID}`]: undefined,
            [`cartPressed_${itemID}`]: undefined
          });

        }
      }
    });
  }

  renderAwaitingRestock(item) {
    if (item.OOS != "1") return null;
    if (parseInt(item.qty) > 0 || this.state.isSearch) {
      return (
        <View style={{
          position: 'absolute',
          left: 16,
          bottom: 120,
          zIndex: 4,
          borderRadius: 8,
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10,
        }}>
          <Image source={awaitingRestock} style={{ width: 35, height: 35 }} resizeMode="contain" />
        </View>
      );
    }
    return (
      <View style={{
        position: 'absolute',
        left: 16,
        bottom: 125,
        zIndex: 4,
        backgroundColor: '#FF8E3D',
        borderRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
        height: 31,
        width: Math.min(Math.max(width - 130, 88), 100),
        paddingHorizontal: 2,
      }}>
        <Text
          numberOfLines={1}
          adjustsFontSizeToFit
          minimumFontScale={0.85}
          style={{
            color: '#FFFFFF',
            fontSize: 10,
            lineHeight: 12,
            textAlign: 'center',
            fontFamily: AppStyles.fontFamily,
            fontWeight: '700',
            flexShrink: 1,
            width: '100%',
          }}
        >
          {STRINGS.awaiting_restock}
        </Text>
      </View>
    );
  }

  renderMobile() {
    width = (Dimensions.get("window").width);
    if (!Commons.isMobile()) {
      width = Commons.getDesktopWidth();
    }
    if (this.state.isSearch) {
    } else {
      // Card width fills the row exactly (gap between cards stays fixed);
      // scale is only used to size inner text/icons, capped so they don't look oversized.
      const layout = Commons.getGridLayout();
      width = layout.cardWidth;
      scale = Math.min(width / 216, 1.15);
    }

    const item = this.state.updatedItem || this.props.item;
    if (!item.SMALL_IMG || item.SMALL_IMG === '') {
      item.SMALL_IMG = item.IMG;
    }
    const { showProductsDetails } = this.props;
    if (item.isDummy) {
      return <View style={{
        marginVertical: this.props.margin ? this.props.margin : 15,
        marginHorizontal: this.props.margin ? this.props.margin : 0,
        width: (width - 30)
      }} />; // Empty placeholder
    }
    return (
      <View style={{ backgroundColor: AppStyles.desktopBackgroundColor }}>
        {
          this.state.isSearch && (
            <View style={{
              flexDirection: 'row',
              alignItems: "flex-start",
              justifyContent: "flex-start",
              borderRadius: 8,
              marginVertical: 10,
              position: 'relative',
              width: (width - 10),
            }}>
              <TouchableOpacity
                activeOpacity={0.7}
                style={{ flexDirection: 'row', gap: 8, }}
                onPress={() => {
                  setTimeout(() => {
                    showProductsDetails(true)
                  }, 300);
                }}
              >
                <Image
                  source={{ uri: item.IMG }}
                  style={{ width: 100, height: 100, borderRadius: 8 }}
                  resizeMode="contain"
                />
                <View style={{ justifyContent: "space-around", width: width - 100 }}>
                  <Text style={[AppStyles.OrderNowDescStyle, { flexGrow: 0, minHeight: 10, width: width - 130 }]} >{item.NAME.toLowerCase()}</Text>
                  <Text style={[AppStyles.orderNowPriceStyle, { marginBottom: 4, marginTop: 12 }]}>{item.PHARMACY_PRICE} JOD</Text>
                </View>
              </TouchableOpacity>
              {/* {Commons.searchAddingItems(this, item, item.ID, '', this.state.itemsNo, '')} */}

              <View style={{ position: 'absolute', bottom: 15, right: 10, width: width - 65, height: 23, zIndex: 10, alignItems: 'flex-end' }}>
                {/* {Commons.searchAddingItems(this, item, item.ID, () => { this.updateCurrentProduct(item.ID) },)} */}
                {this.searchAddingItems(item, item.ID)}
              </View>
              {this.renderAwaitingRestock(item)}

              {(
                (() => {
                  if (item.NEXT_BONUS > 0 && item.NEXT_BONUS_TEXT !== '') {
                    return (
                      <View style={{
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        borderRadius: 6,
                        backgroundColor: '#F28C80', position: 'absolute',
                        left: 16, top: 16, justifyContent: 'center', alignItems: 'center'
                      }}>
                        <Image source={giftIcon2} style={{
                          width: 16,
                          height: 16,
                          // tintColor: '#FFF',
                          position: 'absolute',
                          top: -6,
                          left: -6
                        }} />
                        <Text style={[AppStyles.bonusSearchTextx, { fontSize: 10 }]}>
                          {item.NEXT_BONUS_TEXT}
                        </Text>
                      </View>
                    );
                  }
                  if (item.NEXT_BONUS_TEXT === '' && item.BONUS !== '') {
                    return (
                      <View style={{
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        borderRadius: 6,
                        backgroundColor: '#6BA461', position: 'absolute',
                        left: 16, top: 16, justifyContent: 'center', alignItems: 'center'
                      }}>
                        <Image source={giftIcon3} style={{
                          width: 16,
                          height: 16,
                          position: 'absolute',
                          top: -6,
                          left: -6
                        }} />
                        <Text style={[AppStyles.bonusSearchTextx, { fontSize: 10 }]}>+ {item.BONUS}</Text>
                      </View>
                    )
                  }
                })()
              )}


            </View>
          )
        }

        {
          !this.state.isSearch && (
            <TouchableOpacity
              style={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                borderRadius: 8,
                marginVertical: this.props.margin ? Math.max(this.props.margin - 4, 6) : 8,
                marginHorizontal: this.props.margin ? Math.max(this.props.margin - 4, 0) : 0,
                width: (width - 30),
                backgroundColor: '#fff',
                // marginTop: index < 2 ? 0 : 10
              }}
              onPress={() => {
                showProductsDetails(true);
              }}
            >
              {item && <Image
                source={{ uri: item.IMG }}
                style={{ width: (width - 30), height: (width - 30), borderRadius: 8, marginBottom: 8 }}
                resizeMode={item.IMG.indexOf('product.png') > 0 ? 'cover' : 'contain'}
              />}
              <View style={{ width: width - 65, marginBottom: 26, top: 10 }}>
                <Text style={[AppStyles.OrderNowDescStyle, {}]} numberOfLines={2}>{item.NAME.toLowerCase()}</Text>
                <Text style={[AppStyles.featruredItemsPrice, { marginTop: 8, }]}>{item.PHARMACY_PRICE} JOD</Text>
              </View>
              {/* {Commons.addingItems(this, item, item.ID, () => { this.updateCurrentProduct(item.ID) })} */}
              {this.renderAddingItems(item, item.ID)}
              {this.renderAwaitingRestock(item)}

              {(
                (() => {
                  if (item.NEXT_BONUS > 0 && item.NEXT_BONUS_TEXT !== '') {
                    return (
                      <View style={{
                        paddingHorizontal: 12,
                        paddingVertical: 8,
                        borderRadius: 6,
                        backgroundColor: '#F28C80', position: 'absolute',
                        left: 16, top: 16, justifyContent: 'center', alignItems: 'center'
                      }}>
                        <Image source={giftIcon2} style={{
                          width: 20,
                          height: 20,
                          // tintColor: '#FFF',
                          position: 'absolute',
                          top: -6,
                          left: -6
                        }} />
                        <Text style={[AppStyles.bonusSearchTextx]}>
                          {item.NEXT_BONUS_TEXT}
                        </Text>
                      </View>
                    );
                  }
                  if (item.NEXT_BONUS_TEXT === '' && item.BONUS !== '') {
                    return (
                      <View style={{
                        paddingHorizontal: 12,
                        paddingVertical: 8,
                        borderRadius: 6,
                        backgroundColor: '#6BA461', position: 'absolute',
                        left: 16, top: 16, justifyContent: 'center', alignItems: 'center'
                      }}>
                        <Image source={giftIcon3} style={{
                          width: 20,
                          height: 20,
                          position: 'absolute',
                          top: -6,
                          left: -6
                        }} />
                        <Text style={[AppStyles.bonusSearchTextx]}>+ {item.BONUS}</Text>
                      </View>
                    )
                  }
                })()
              )}

            </TouchableOpacity>
          )}
      </View>
    )
  }


  searchAddingItems = (item, itemID) => {
    // let qty = self.state.tempQty && self.state.tempQty[item.ID] ? self.state.tempQty[item.ID] : 1;
    let qty = parseInt(item.qty) > 0 ? parseInt(item.qty) : 0;
    // if (this.state[`cartPressed_${item.ID}`] === undefined) {
    //   this.state[`cartPressed_${item.ID}`] = Commons.checkItemIsInBasket(this, item.ID).inBasket;
    // }
    if (!this.state[`cartPressed_${item.ID}`]) {
      return (
        <View>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={async () => {
              item.qty = 0;
              this.addItemsToBasket(this, item, item.ID, 1, this.updateCurrentProduct);
              this.setState(prevState => {
                const tempQty = { ...(prevState.tempQty || {}) };
                tempQty[itemID] = 1;
                return {
                  tempQty,
                  [`itemQty${itemID}`]: 1,
                  [`cartPressed_${itemID}`]: true,
                  itemsNo: prevState.itemsNo + 1,
                };
              });
              // this.updateCurrentProduct(item.ID);
              // await Commons.updateItemsNo(this, "add", qty);
              // itemsNo(await Commons.updateItemsNo(this, "", ''));
            }}
            style={{ width: 36, height: 36, alignItems: 'center', justifyContent: 'center', zIndex: 3 }}>
            <Image source={circlePlus} style={{ width: 24.972, height: 24.972 }} />
          </TouchableOpacity>
        </View>
      );
    }

    // Create a ref for the Animatable.Text if not already created
    if (!this[`qtyAnimRef_${itemID}`]) this[`qtyAnimRef_${itemID}`] = React.createRef();

    return (
      <View style={{ justifyContent: 'center', alignItems: 'center', marginEnd: 5 }}>
        <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', gap: 4, }}>
          {/* <Image source={giftIcon} style={{ width: 12.016, height: 12.084, tintColor: '#6BA461' }} />
        <Text style={[AppStyles.giftText]}> + {item.BONUS}</Text> */}
        </View>
        <View
          style={{
            flexDirection: 'row', gap: 10, padding: 4, paddingHorizontal: 8,
            alignItems: 'center', backgroundColor: '#6BA461', borderRadius: 20, justifyContent: 'space-between', zIndex: 3
          }}>
          <TouchableOpacity style={{ zIndex: 3, width: 14, height: 22, alignItems: 'center', justifyContent: 'center' }}
            onPress={async () => {
              this.state[`itemQty${itemID}`] = (this.state[`itemQty${itemID}`] || 1) - 1;
              if (this.state[`itemQty${itemID}`] <= 0) {
                this.setState(prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                  // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  return {
                    tempQty,
                    [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                    itemsNo: this.state.itemsNo - 1,
                  };
                });
                // await Commons.updateItemsNo(this, "decrease", qty);
                this.deleteItem(this, item, itemID);
                // this.updateCurrentProduct(item.ID);
                // itemsNo(await Commons.updateItemsNo(this, "", ''));

              } else {
                this.addItemsToBasket(this, item, item.ID, - 1, this.updateCurrentProduct);
                this.setState(prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                  // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  return {
                    tempQty,
                  };
                });
              }
              // this.updateCurrentProduct(item.ID);
            }}>
            <Image source={minus} style={{ width: 12, height: 1.5, tintColor: '#FFF' }} />
          </TouchableOpacity>
          <View style={{ zIndex: 3, width: qty > 999 ? 45 : qty > 99 ? 35 : qty > 9 ? 25 : 15 }}>
            <TextInput
              ref={this[`qtyAnimRef_${itemID}`]}
              style={[
                AppStyles.featuredItemsQtyStyle,
                { textAlign: 'center', padding: 0, margin: 0, backgroundColor: 'transparent' }
              ]}
              // value={qty.toString()}
              keyboardType={"number-pad"}
              selectTextOnFocus={true}
              value={this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`].toString() : 1}
              onFocus={() => {
                this.setState({ [`itemQty${itemID}`]: this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`] : 1 });
              }}
              onChangeText={async (text) => {
                // Only allow numbers
                let newQty = parseInt(text.replace(/[^0-9]/g, ''), 10);
                if (isNaN(newQty) || newQty <= 0) {
                  this.setState(prevState => {
                    const tempQty = { ...(prevState.tempQty || {}) };
                    tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                    return {
                      tempQty,
                      [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                      itemsNo: this.state.itemsNo - 1,
                    };
                  });
                  this.deleteItem(this, item, itemID);

                  // await Commons.updateItemsNo(this, "", '');
                  // itemsNo(await Commons.updateItemsNo(this, "", ''));
                  // this.updateCurrentProduct(item.ID);
                } else {
                  this.state[`itemQty${itemID}`] = newQty;
                  this.addItemsToBasket(this, item, item.ID, newQty - item.qty, this.updateCurrentProduct);
                  this.setState(prevState => {
                    const tempQty = { ...(prevState.tempQty || {}) };
                    tempQty[itemID] = newQty;
                    return { tempQty };
                  });
                  // this.updateCurrentProduct(item.ID);
                  // await Commons.updateItemsNo(this, "add", qty);
                  // itemsNo(await Commons.updateItemsNo(this, "", ''));
                }
              }}
            />
          </View>
          <TouchableOpacity style={{ width: 14, height: 22, alignItems: 'center', justifyContent: 'center' }}
            onPress={async () => {
              this.setState(
                prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = (tempQty[itemID] || 1) + 1;
                  this.state[`itemQty${itemID}`] = (this.state[`itemQty${itemID}`] || 1) + 1;
                  return { tempQty };
                });
              this.addItemsToBasket(this, item, item.ID, 1, this.updateCurrentProduct);
              // this.updateCurrentProduct(item.ID);
            }}>
            <Image source={plus} style={{ width: 12, height: 12, tintColor: '#FFF' }} />
          </TouchableOpacity>
        </View>
      </View >
    );
  };



  renderAddingItems = (item, itemID) => {
    const { itemsNo, itemQty } = this.props;
    // if (itemQty && itemQty !== 0 || itemQty !== '' || itemQty !== undefined) {this.state[`itemQty${itemID}`] = itemQty; }
    let qty = this.state[`itemQty${itemID}`] && this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`] : 1;

    if (!this.state[`cartPressed_${item.ID}`]) {
      return (
        <TouchableOpacity style={{
          padding: 12,
          margin: 12,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
          alignContent: 'center',
          right: 0,
          bottom: 100,
          zIndex: 4
        }} onPress={async () => {
          item.qty = 0;
          this.addItemsToBasket(this, item, item.ID, 1, this.updateCurrentProduct);
          this.setState(prevState => {
            const tempQty = { ...(prevState.tempQty || {}) };
            tempQty[itemID] = 1;
            return {
              tempQty,
              [`itemQty${itemID}`]: 1,
              [`cartPressed_${itemID}`]: true,
              itemsNo: prevState.itemsNo + 1,
            };
          });
          // this.updateCurrentProduct(item.ID);
          // await Commons.updateItemsNo(this, "add", qty);
          // itemsNo(await Commons.updateItemsNo(this, "", ''));
        }}>
          <Image source={circlePlus} style={{ width: 31, height: 31 }} />
        </TouchableOpacity>
      );
    }
    // Create a ref for the Animatable.Text
    if (!this[`qtyAnimRef_${itemID}`]) this[`qtyAnimRef_${itemID}`] = React.createRef();

    return (
      <TouchableOpacity style={{ padding: 20, position: 'absolute', right: 0, bottom: 100, zIndex: 2 }}>
        <View style={{
          height: 34, flexDirection: 'row', gap: 5, paddingHorizontal: 8,
          alignItems: 'center', justifyContent: 'center', backgroundColor: '#6BA461', borderRadius: 20,
        }} >
          <TouchableOpacity
            style={{ zIndex: 3, width: 22, height: 22, alignItems: 'center', justifyContent: 'center', marginLeft: 5 }}
            onPress={async () => {
              this.state[`itemQty${itemID}`] = (this.state[`itemQty${itemID}`] || 1) - 1;
              if (this.state[`itemQty${itemID}`] <= 0) {
                this.setState(prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                  // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  return {
                    tempQty,
                    [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                    itemsNo: this.state.itemsNo - 1,
                  };
                });
                this.deleteItem(this, item, itemID);
                // this.updateCurrentProduct();
                // await Commons.updateItemsNo(this, "decrease", qty);
                // itemsNo(await Commons.updateItemsNo(this, "", ''));

              } else {
                this.addItemsToBasket(this, item, item.ID, - 1, this.updateCurrentProduct);
                this.setState(prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                  // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                  return {
                    tempQty,
                  };
                });
              }
            }}>
            <Image source={minus} style={{ width: 14, height: 2, marginRight: 5, tintColor: '#FFF' }} />
          </TouchableOpacity>
          <View style={{ zIndex: 3, width: qty > 999 ? 45 : qty > 99 ? 35 : qty > 9 ? 25 : 15 }}>
            <TextInput
              ref={this[`qtyAnimRef_${itemID}`]}
              style={[
                AppStyles.featuredItemsQtyStyle,
                { textAlign: 'center', padding: 0, margin: 0, backgroundColor: 'transparent' }
              ]}
              // value={qty.toString()}
              keyboardType={"number-pad"}
              selectTextOnFocus={true}
              value={
                (this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`].toString() : 1)
              }
              onFocus={() => {
                this.setState({ [`itemQty${itemID}`]: this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`] : 1 });
              }}
              onChangeText={async (text) => {
                // Only allow numbers
                let newQty = parseInt(text.replace(/[^0-9]/g, ''), 10);
                if (isNaN(newQty) || newQty <= 0) {
                  this.setState(prevState => {
                    const tempQty = { ...(prevState.tempQty || {}) };
                    tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                    return {
                      tempQty,
                      [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                      itemsNo: this.state.itemsNo - 1,
                    };
                  });
                  this.deleteItem(this, item, itemID);
                  // this.updateCurrentProduct(item.ID);
                  // await Commons.updateItemsNo(this, "", '');
                  // itemsNo(await Commons.updateItemsNo(this, "", ''));
                  // this.updateCurrentProduct(item.ID);
                } else {
                  this.state[`itemQty${itemID}`] = newQty;
                  this.addItemsToBasket(this, item, item.ID, newQty - item.qty, this.updateCurrentProduct);
                  this.setState(prevState => {
                    const tempQty = { ...(prevState.tempQty || {}) };
                    tempQty[itemID] = newQty;
                    return { tempQty };
                  });
                  // await Commons.updateItemsNo(this, "add", qty);
                  // itemsNo(await Commons.updateItemsNo(this, "", ''));
                }

              }}
            />
          </View>
          <TouchableOpacity
            style={{ zIndex: 3, width: 22, height: 22, alignItems: 'center', justifyContent: 'center', marginRight: 1 }}
            onPress={async () => {
              this.setState(
                prevState => {
                  const tempQty = { ...(prevState.tempQty || {}) };
                  tempQty[itemID] = (tempQty[itemID] || 1) + 1;
                  this.state[`itemQty${itemID}`] = (this.state[`itemQty${itemID}`] || 1) + 1;
                  return { tempQty };
                });

              this.addItemsToBasket(this, item, item.ID, + 1, this.updateCurrentProduct);
            }}>
            <Image source={plus} style={{ width: 14, height: 14, tintColor: '#FFF' }} />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  }

  deleteItem = async () => {
    const itemID = this.props.item.ID;
    this.props.item.qty = 0;
    this.props.item.BONUS = this.state.orgItem.BONUS;
    this.props.item.NEXT_BONUS_TEXT_LONG = this.state.orgItem.NEXT_BONUS_TEXT_LONG;
    this.props.item.NEXT_BONUS_TEXT = this.state.orgItem.NEXT_BONUS_TEXT;
    this.props.item.NEXT_BONUS = this.state.orgItem.NEXT_BONUS;

    if (this.addToBasketTimeout) {
      clearTimeout(this.addToBasketTimeout);
    }
    this.setState({ [`calculating_${itemID}`]: true });
    // Defer the write so a burst of qty changes results in a single basket update.
    this.addToBasketTimeout = setTimeout(() => {
      // Cleared as soon as the write starts so the pending guard doesn't outlive it.
      this.addToBasketTimeout = null;
      Commons.deleteItemsFromBasket(this, this.props.item, itemID, () => {
        this.setState({ updatedItem: this.state.orgItem, [`calculating_${itemID}`]: false });
      }).catch(() => { }).finally(() => this.setBasketBusy(!!this.addToBasketTimeout));
    }, QTY_UPDATE_DEBOUNCE_MS);
    this.setBasketBusy(true);



    // self.updateCurrentProduct(item.ID);
  }

  addItemsToBasket = async (self, item, itemID, qty, callback) => {
    item.qty += parseInt(qty);
    if (this.addToBasketTimeout) {
      clearTimeout(this.addToBasketTimeout);
    }
    this.setState({ [`calculating_${itemID}`]: true });
    // Defer the write so a burst of qty changes results in a single basket update.
    this.addToBasketTimeout = setTimeout(() => {
      // Cleared as soon as the write starts so the pending guard doesn't outlive it.
      this.addToBasketTimeout = null;
      Commons.addItemsToBasket(self, item, itemID, item.qty, (orderResp) => {
        this.setState({ [`calculating_${itemID}`]: false });
        if (callback) callback(orderResp);
      }).catch(() => { }).finally(() => this.setBasketBusy(!!this.addToBasketTimeout));
    }, QTY_UPDATE_DEBOUNCE_MS);
    this.setBasketBusy(true);
  }

  updateCurrentProduct = async () => {
    // const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
    try {
      const thisItem = this.state.updatedItem || this.props.item;
      const parsedItems = await Commons.getBasketItems();
      if (parsedItems) {
        const foundItem = parsedItems.find(item => item.ID === thisItem.ID);
        if (foundItem) {
          this.setState({ updatedItem: foundItem, });
        } else {
          this.props.item.qty = 0;
          this.props.item.BONUS = '';
          this.props.item.NEXT_BONUS_TEXT_LONG = '';
          this.props.item.NEXT_BONUS_TEXT = '';
          this.props.item.NEXT_BONUS = 0;
          this.setState({ updatedItem: this.props.item, [`itemQty${thisItem.ID}`]: undefined, [`cartPressed_${thisItem.ID}`]: undefined });
        }
      }
    } catch (e) {
      console.log('Failed to parse ITEMS_IN_BASKET:', e);
    }
  };


  render() {
    // const xwidth = Math.max(Dimensions.get("window").width, Constants.MIN_WIDTH);
    // width = (xwidth - 80) / (Commons.getNumColumns() + 1);
    // styles = this.styles();
    // // const item = this.props.item;
    // // const plusIcon = require("../assets/icons/plus.png");
    // // const minusIcon = require("../assets/icons/minus.png");
    // // const infoIcon = require("../assets/info.png");
    // // isMobile = Commons.isMobile();
    isMobile = true;
    if (isMobile) {
      styles = this.styles();
      return this.renderMobile();
      // return this.renderDesktop();
    }

  }




  styles = () => (
    {
      container: {
        flex: 1,
        paddingVertical: 4,
        justifyContent: "center",
        alignItems: "center",
      },
      image: {
        width: width + 20,
        height: width + 20,
        marginTop: 5,
        marginLeft: -10
      },
      titleView: {
        width: width - 6,
        // position: 'absolute',
        bottom: 0,
        padding: 5,
      },
      tag: {
        fontFamily: "riposte",
        fontSize: 14,
        padding: 3,
        marginBottom: 2,
        marginLeft: -10,
        color: "white",
        backgroundColor: Constants.appColor,
      },
      titleContainer: {
        width: "100%",
      },
      title: {
        width: "70%",
        fontFamily: "zarid",
        color: "#6b3529",
        fontSize: 16,
        fontWeight: '400',
        marginTop: 5,
        textAlign: direction,
      },
      text: {
        fontFamily: "riposte",
        color: "#6b3529",
        fontSize: 14,
      },
      unit: {
        fontFamily: "riposte",
        color: "#6b3529",
        fontSize: 14,
        // backgroundColor: "#99CCE9",
        top: width,
        right: 0,
        marginTop: 35,
        position: "absolute",
      },
      price: {
        fontFamily: "riposte",
        color: "#6b3529",
        // backgroundColor: '#ed9c26',
        fontSize: 14,
        marginTop: 5,
        textAlignVertical: "center",
        textAlign: "right",
        padding: 2,
        top: width + 45,
        right: 0,
        position: "absolute",
      },

      leftTopView: {
        position: "absolute",
        top: 0,
        left: 0,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-end",
        paddingBottom: 0,
      },
      rightTopView: {
        position: "absolute",
        top: 10,
        right: -5,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        paddingBottom: 0,
      },
      qtyOptionsView: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 0,
        // textShadowColor: Constants.appColor,
        alignSelf: "center",
        backgroundColor: "white",
        padding: 5,
      },

      qtyView: {
        alignItems: "center",
        justifyContent: "center",
        paddingVertical: Platform.select({ ios: 4, android: 0 }),
        marginHorizontal: 4,
        minWidth: 32,

        // backgroundColor: Color.GREY[200],
        // ...Styles.border
      },
      qtyText: {
        fontFamily: "riposte",
        fontSize: 14,
        color: "white",
      },
    }
  );
}


export default FeaturedItem;
